const initialExpense = {
    expenses: [],
    expensesdropdown : [],
    expensemessages:{}
};

const ExpenseReducer = (expense = initialExpense, action) => {
    switch (action.type) {
        case 'GET_EXPENSE':
            return {
                ...expense, expenses: action.payload.data
            };
            case "ADD_EXPENSE":
              return {
                ...expense, expensemessages: action.payload.data
            };
            case 'UPDATE_EXPENSE':
              return {
                ...expense, expensemessages: action.payload.data
            };
            case 'GET_EXPENSE_DROPDOWN':
              return {
                ...expense, expensesdropdown: action.payload.data
            };
          default:
            return expense;
    }
}
export default ExpenseReducer;